import hljs from "highlight.js/lib/common";

export default hljs;
